export const NON_MEMBER_ROLES = ['Org Admin', 'Admin', 'Editor', 'Dev'] as const

export const isNonMemberRole = (role: string | null | undefined): boolean => {
  return role ? NON_MEMBER_ROLES.includes(role as any) : false
}

export interface RolePermissions {
  isOrgAdmin: boolean
  isCurrentInstanceAdmin: boolean
  isCurrentInstanceEditor: boolean
  isOrgDeveloper: boolean
}

/**
 * Determine user role based on permissions
 */
export const determineUserRole = (permissions: RolePermissions): string => {
  const { isOrgAdmin, isCurrentInstanceAdmin, isCurrentInstanceEditor, isOrgDeveloper } = permissions

  if (isOrgAdmin) {
    return 'Org Admin'
  }
  if (isOrgDeveloper) {
    return 'Dev'
  }
  if (isCurrentInstanceAdmin) {
    return 'Admin'
  }
  if (isCurrentInstanceEditor) {
    return 'Editor'
  }
  return 'Member'
}

/**
 * Get the icon class for a given role
 */
export const getRoleIcon = (role: string | null | undefined): string => {
  switch (role) {
    case 'Org Admin':
      return 'fa-solid fa-sitemap'
    case 'Admin':
      return 'fa-solid fa-star'
    case 'Editor':
      return 'fa-solid fa-edit'
    case 'Dev':
      return 'fa-solid fa-code'
    case 'User':
    default:
      return 'fa-solid fa-user'
  }
}
